import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'
import gigJobPartiesMixin from './gigJobPartiesMixin'
import { cancelDoneGig, doneGig } from '@/api/gigs/gigJobs/gigJobs'
import { GigJobStages } from '@/constants/gig/gigJobStages'
import { RootState } from '@/store'
import notifiableRequest from '@/utils-ts/notifiableRequest'

export default Vue.extend({
  mixins: [gigJobPartiesMixin],
  data() {
    return {
      donning: false,
      cancelDone: false,
    }
  },
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    hasGigDone() {
      return this.isWorker && !this.application?.isDone && this.application.job?.stage === GigJobStages.IN_PROGRESS
    },
    hasGigWasDone() {
      return this.application?.isDone && this.application.job?.stage === GigJobStages.IN_PROGRESS
    },
  },
  methods: {
    ...mapMutations({
      setGigIsDone: 'gigChat/setGigIsDone',
    }),
    async markGigJobAsDone() {
      this.donning = true
      try {
        await notifiableRequest({
          request: async () => {
            await doneGig(this.application.job.id)
            this.setGigIsDone({ id: this.application.id, isDone: true })
          },
          title: 'Completing gig',
          successText: 'Gig marked as complete.',
          failureText: 'Error submitting request. Please try again.',
        })
      } finally {
        this.donning = false
      }
    },
    async markGigJobAsNotDone() {
      this.cancelDone = true
      try {
        await notifiableRequest({
          request: async () => {
            await cancelDoneGig(this.application.job.id)
            this.setGigIsDone({ id: this.application.id, isDone: false })
          },
          title: 'Completing gig',
          successText: 'Gig marked as incomplete.',
          failureText: 'Error submitting request. Please try again.',
        })
      } finally {
        this.cancelDone = false
      }
    },
  },
})
